// Navigation and permission types

export interface Permission {
    id: string
    name: string
    category: PermissionCategory
    description: string
    level: PermissionLevel
    expiryDate?: string
}

export enum PermissionCategory {
    DASHBOARD = 'dashboard',
    CATALOG = 'catalog',
    INVENTORY = 'inventory',
    ORDERS = 'orders',
    CUSTOMERS = 'customers',
    SALES = 'sales',
    CONFIGURATION = 'configuration',
    ANALYTICS = 'analytics',
    BILLING = 'billing'
}

export enum PermissionLevel {
    READ = 'read',
    WRITE = 'write',
    DELETE = 'delete',
    ADMIN = 'admin'
}

export interface QuickAction {
    id: QuickActionType
    label: string
    icon: string
    shortcut: string
    permission: string
    path: string
    description: string
}

export enum QuickActionType {
    CREATE_SALE = 'create_sale',
    CREATE_ORDER = 'create_order',
    CREATE_SALES_ORDER = 'create_sales_order',
    CREATE_CUSTOMER = 'create_customer',
    TAKE_PAYMENT = 'take_payment'
}

export interface UserProfile {
    id: string
    email: string
    name?: string
    role: string
    permissions: Record<string, boolean>
    isActive: boolean
    createdAt: string
    updatedAt: string
}

export interface PermissionRequest {
    permissionId: string
    reason: string
    requestedBy: string
    requestedAt: string
}

export interface MenuItem {
    text: string
    icon: React.ReactElement
    path?: string
    permission?: string
    requiredPermissions?: string[]
    children?: MenuItem[]
    badge?: {
        count: number
        color: 'error' | 'warning' | 'info' | 'success'
    }
    external?: boolean  // Opens in new tab
    separator?: boolean  // Renders as a divider
    sectionLabel?: boolean  // Renders as a muted section header label
    footer?: boolean  // Rendered in the fixed footer area of the sidebar, not the scrollable list
}